
<template>
  <ModalWrapper v-if="state.visible" :size="'sm'" :calcHeight="false" :showClose="false" @close-modal="$emit('cancel')" >
    <template #header>
      <h4>{{state.description}}</h4>
    </template>
    <template #body>
      <button @click="state.resolve" :class="`pull-right btn btn-${state.type}`">{{state.acceptMessage}}</button>
      <button @click="state.reject" style="margin-right: 1.5rem;" class="pull-right btn btn-warning">{{state.rejectMessage}}</button>
    </template>
  </ModalWrapper>
</template>

<script>
import { mapState } from "vuex"

import ModalWrapper from "@/components/Modals/ModalWrapper";

export default {
  components: { ModalWrapper },
  computed:  {
    ...mapState({
      state: (x) => x.confirm,
    })
  }
};
</script>